export function Avatar({ user, size = 32, className = "", textClass = "text-sm" }) {
  const src = user?.avatar_url || user?.picture;
  const initial = (user?.name || user?.email || "?").trim().charAt(0).toUpperCase();
  const style = { width: size, height: size };
  if (src) {
    return <img src={src} alt={user?.name || "avatar"} style={style} data-testid="user-avatar-img"
      className={`rounded-full object-cover bg-neutral-100 ${className}`} />;
  }
  return (
    <span style={style} data-testid="user-avatar-initial"
      className={`rounded-full bg-brand/10 text-brand font-bold flex items-center justify-center shrink-0 ${textClass} ${className}`}>
      {initial}
    </span>
  );
}
